// extracted by mini-css-extract-plugin
export default {"add-new":"_2RHah","addNew":"_2RHah"};